import {gql} from 'apollo-angular';

export const gql_getHojaVidaByCi = gql`
query($ci:String){
    getHojaVidaByCi(_ci:$ci){
        idhoja
        fnacimiento
        nacionalidad
        ciudad
        telefono
        correo
        estcivil
        direccion
        genero
        militar
        fotografia
        archivo
        codusuario
        estudios {
            idestudio
            tipo
            institucion
            nivel
            area
            g_inicio
            g_fin
            titulo
          }
        cursos {
          idcurso
          detalle
          institucion
          detperiodo
          horas
        }
        experiencia {
          idexp
          entidad
          cargo
          funciones
          f_inicio
          f_fin
        }
    }
}
`;

export const gql_listahojavida = gql`
query($ci:String){
    listahojavida(_ci:$ci){
        idhoja
        fnacimiento
        nacionalidad
        ciudad
        telefono
        correo
        estcivil
        direccion
        genero
        militar
        fotografia
        archivo
    }
}
`;

export const gql_listakardexgral = gql`
query ($habil:String){
    listadoCVGeneral(habil:$habil){
        idcarnet
        nombres
        appaterno
        apmaterno
        estado
        editar
        edad
        ciudad
        telefono
        correo
        estcivil
        direccion
        genero
        cursos
        estudios
        experiencia
  }
}`;

export const gql_listaUsuariosConHojaVida = gql`
query($ci:String){
    listaUsuariosConHojaVida(_ci:$ci){
        idcarnet
        expedido
        nombres
        appaterno
        apmaterno
        editar
        idhoja
        fnacimiento
        nacionalidad
        ciudad
        telefono
        correo
        estcivil
        direccion
        genero
        militar
        fotografia
        archivo
    }
}
`;

export const gql_listaDecJurada = gql`
query($ci:String){
    listaDecJurada(ci:$ci){
        idjurada
        fecha
        gestion
        habilitado
        primero
        segundo
        tercero
        codusuario
    }
}
`;

export const gql_listaParentesco = gql`
query($ci:String){
    listaParentesco(ci:$ci){
        idparentesco
        nombres
        appaterno
        apmaterno
        detalle
        codusuario
    }
}
`;

export const gql_creaOActualizaHojaDeVida = gql`
mutation ($datos:HojaInput){
    creaOActualizaHojaDeVida(input:$datos)
}`;

export const gql_creaOActualizaEstudios = gql`
mutation ($datos:[EstudiosInput], $codHoja:Int){
    creaOActualizaEstudios(input:$datos, codHoja:$codHoja)
}`;

export const gql_creaOActualizaCursos = gql`
mutation ($datos:[CursosInput], $codHoja:Int){
    creaOActualizaCursos(input:$datos, codHoja:$codHoja)
}`;

export const gql_creaOActualizaExperiencia = gql`
mutation ($datos:[ExperienciaInput], $codHoja:Int){
    creaOActualizaExperiencia(input:$datos, codHoja:$codHoja)
}`;

export const gql_deleteElement = gql`
mutation ($idelement:Int, $tablename:String, $tableid:String){
    deleteElement(idelement:$idelement, tablename:$tablename, tableid:$tableid)
}`;

export const gql_aprobarkardex = gql`
mutation ($personal:String, $ci:String){
    aprobarKardex(personal:$personal, ci:$ci)
}`;


export const gql_cambiaedicion = gql`
mutation ($ci:String,$valor:Boolean){
    cambiaedit(ci:$ci,valor:$valor)
}`;

export const gql_cambiahabilitado = gql`
mutation ($ci:String,$valor:String){
    cambiahabil(ci:$ci,valor:$valor)
}`;

export const gql_Actualizaparentesco = gql`
mutation ($datos:ParentescoIn){
    actualizaParentesco(input:$datos)
}`;

export const gql_Actualizadecjurada = gql`
mutation ($datos:JuradaIn){
    actualizaDecJurada(input:$datos)
}`;

export const gql_eliminadecjurada = gql`
mutation ($cod:String){
    eliminaDecJurada(cod:$cod)
}`;

export const gql_eliminaParentesco = gql`
mutation ($cod:BigInt){
    eliminaParentesco(cod:$cod)
}`;

export const gql_estadoeditar = gql`
mutation ($valor:Boolean){
    cambiaedicion(valor:$valor)
}`;